import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {CardTask, ITaskItem} from '../cards/CardTask';

interface ITaskItems extends Array<ITaskItem> {
}

const Tasks = () => {
    const [tasks, setTasks] = useState<ITaskItems>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const API_URL = import.meta.env.VITE_APP_API_URL;

    // React-defined tasks
    const baseItems: ITaskItems = [
        {
            type: 'firstCompany',
            status: false,
            is_next: false,
            icon: 'home',
            title: 'Set Up Your First Company',
            text: 'Start by creating your company – the foundation for organizing jobs and candidates. Add it easily: upload from a URL, drag and drop your file, or copy and paste the details. Once done, you’re ready to add jobs and match candidates!',
            button_text: 'Set Up Your First Company',
            button_link: '/companies',
            variant: 'progress-primary',
            value: 0,
            steps: 0,

        },
        {
            type: 'firstJob',
            status: false,
            is_next: false,
            icon: 'briefcase',
            title: 'Add Your First Job',
            text: 'Add your first job by uploading a description you already have. This quick start lets you immediately begin matching candidates, streamlining your hiring process!',
            button_text: 'Add a Job',
            button_link: '/jobs',
            variant: 'progress-primary',
            value: 0,
            steps: 0,

        },
        {
            type: 'firstCandidate',
            status: false,
            is_next: false,
            icon: 'user',
            title: 'Add Your First Candidate',
            text: 'Introduce your first candidate by uploading a CV, pasting their details, or importing from a URL. This gets you one step closer to finding the perfect job match!',
            button_text: 'Add a Candidate',
            button_link: '/candidates',
            variant: 'progress-primary',
            value: 0,
            steps: 0,
        },
    ];

    // Fetch tasks from the API and filter only those matching baseItems
    const fetchTasks = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_URL}/tasks`);
            const apiTasks: ITaskItem[] = response.data;

            // Reduce baseItems to only those with a matching API entry
            const enrichedTasks: ITaskItems = baseItems.reduce((acc, baseItem) => {
                const apiTask = apiTasks.find((item) => item.type === baseItem.type);
                if (apiTask) {
                    acc.push({
                        ...baseItem,
                        status: apiTask.status,
                        is_next: apiTask.is_next,
                        value: apiTask.value,
                        steps: apiTask.steps

                    });
                }
                return acc;
            }, [] as ITaskItems);

            setTasks(enrichedTasks);
        } catch (error) {
            console.error('Failed to fetch tasks:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTasks();
    }, []);

    const renderItem = (item: ITaskItem, index: number) => (
        <React.Fragment key={index}>
            <CardTask
                type={item.type}
                status={item.status}
                is_next={item.is_next}
                icon={item.icon}
                title={item.title}
                text={item.text}
                button_text={item.button_text}
                button_link={item.button_link}
                variant={item.variant}
                value={item.value}
                steps={item.steps}

            />
        </React.Fragment>
    );

    return (
        <>
            {!loading && tasks.length === 0 ? null : (
                <div className="card">
                    <div className="card-header">
                        <h3 className="card-title">Let’s Get You Set Up</h3>
                    </div>
                    <div className="card-body p-5 lg:p-7.5 lg:pb-7">
                        {loading ? (
                            <div>Loading tasks...</div>
                        ) : (
                            <div className="flex flex-no-wrap scrollable-x gap-5">
                                {tasks.map((item, index) => renderItem(item, index))}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export {Tasks};
